import { Item } from './Item';
import { DefinitionList as Root, Definition } from './styled';
export const DefinitionList = {
    Root,
    Item,
    Definition,
};
